import React, { Component } from 'react';
import './Preview.css';

import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withAuthorization, withStorageSync } from '../../session/index';
import * as ROUTES from '../../constants/routes';
import { getPostByUid } from '../../firebase/api/post';
import { Container, Row } from 'reactstrap';
import Information from '../../components/post/information/Information';
import {
    PendingPostIcon,
    PublicFeedIcon,
    YourPostsIcon,
} from '../../components/elements/icons/Icons';
import { getUserRole } from '../../static/localStorage';
import * as ROLES from '../../constants/roles';
import FilterQuestionBar from '../../components/post/elements/FilterQuestionBar';
import Grid from '../../components/post/grid/Grid';

class Preview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            posts: [],
        };
    }

    componentDidMount() {
        const { match } = this.props;
        const { posts } = this.state;
        getPostByUid(match.params['id']).then(result => {
            if (result) {
                posts.push(result);
                this.setState({ posts });
            } else {
                this.props.history.push(ROUTES.LANDING);
            }
        });
    }

    render() {
        const { posts } = this.state;
        return (
            <Container className={'preview-page'} fluid>
                <div className="postsWrapper row">
                    <Grid posts={posts} isPreview={true} activeTabPosts={true} />
                </div>
            </Container>
        );
    }
}

const condition = authUser => !!authUser;

export default compose(withAuthorization(condition), withRouter, withStorageSync)(Preview);
